import { datadogLogs } from '@datadog/browser-logs'
import { sha256 } from 'js-sha256'
import { config } from '../config'
// eslint-disable-next-line import/no-cycle
import { maskifyCard } from '../helpers/common'

class DatadogAdapter {
  constructor() {
    this.scopes = {}
  }

  setTransactionId(transactionId) {
    this.scopes.transactionId = transactionId
    datadogLogs.setGlobalContextProperty('opp', this.scopes)
  }

  setTenantId(tenantId) {
    this.scopes.tenantId = tenantId
    datadogLogs.setGlobalContextProperty('opp', this.scopes)
  }

  setCardIdentification(
    cardNumber = '',
    cardholderName = '',
    cardExpirationMonth = 0,
    cardExpirationYear = 0
  ) {
    let card = cardNumber

    const isMaskedCard = card.includes('X')

    if (!isMaskedCard) {
      card = maskifyCard(card)
    }

    this.scopes.cardHash = sha256(
      `${card}|${cardholderName.toUpperCase()}|${cardExpirationMonth}/${cardExpirationYear}`
    )
    datadogLogs.setGlobalContextProperty('opp', this.scopes)
  }

  init() {
    datadogLogs.init({
      clientToken: config.datadogClientToken,
      site: 'datadoghq.eu',
      proxyUrl: config.datadogProxyUrl,
      sampleRate: 100,
      service: 'opp',
      flushTimeout: 1500,
      env: config.env,
      version: config.version,
      forwardErrorsToLogs: false,
    })

    datadogLogs.setGlobalContextProperty('businessunit', 'payment')
    datadogLogs.setGlobalContextProperty('application', 'opp')
    datadogLogs.setGlobalContextProperty('host', window.location.host)

    window.onerror = (msg, url, lineNo, columnNo, error) => {
      if (url) {
        const urlPathName = new URL(url).pathname

        // log only MFE errors
        if (/tui-payments-opp.js/i.test(urlPathName)) {
          this.error('Error from browser console', {
            msg,
            url,
            lineNo,
            columnNo,
            error,
          })
        }
      }
    }

    const { error } = console
    console.error = (...args) => {
      error(...args)

      this.info("Error from browser console (might be Tenant's one)", {
        ...args,
      })
    }

    // TODO: add "AWS account friendly name" like tuigroup-opp-dev or something
    //       when 'env' will be dynamic value. ticket OPP-2090
    // datadogLogs.addLoggerGlobalContext('account', '')
  }

  info(message, logData) {
    datadogLogs.logger.info(message, { logData })
  }

  warn(message, logData) {
    datadogLogs.logger.warn(message, { logData })
  }

  error(message, logData) {
    datadogLogs.logger.error(message, { logData })
  }
}

export const DataDog = new DatadogAdapter()

if (process.env.NODE_ENV !== 'dev' && process.env.NODE_ENV !== 'test') {
  DataDog.init()
}
